/* eslint-disable indent */
import React from 'react';
import { Typography, CircularProgress, Box } from '@material-ui/core';
import LockIcon from '@material-ui/icons/Lock';
import i18n from 'i18n';
import { history } from 'store';

const DeviceValidationStatus: React.FC = () => {
  const [status, setStatus] = React.useState<'pending' | 'success' | 'error'>(
    'pending'
  );

  React.useEffect(() => {
    const timeout = setTimeout(() => {
      const result = 'success';
      setStatus(result as 'success' | 'error');
    }, 2000);

    return () => clearTimeout(timeout);
  }, []);

  React.useEffect(() => {
    if (status !== 'pending') {
      const redirectTimeout = setTimeout(() => {
        history.push('/home/environments');
      }, 1000);

      return () => clearTimeout(redirectTimeout);
    }
  }, [status]);

  const getIcon = () => {
    const style = {
      fontSize: 48,
      color:
        status === 'success'
          ? '#4caf50'
          : status === 'error'
          ? '#f44336'
          : '#9e9e9e',
    };

    return <LockIcon style={style} />;
  };

  const getText = () => {
    if (status === 'pending') return i18n.t('VALIDATING_DEVICE_KEY');
    if (status === 'success') return i18n.t('DEVICE_VALIDATED_KEY');
    return i18n.t('DEVICE_INVALID_KEY');
  };

  return (
    <div style={{ textAlign: 'center', marginTop: 40 }}>
      <Box position="relative" display="inline-flex">
        {status === 'pending' && (
          <CircularProgress
            size={108}
            thickness={2}
            style={{ color: '#1976d2' }}
          />
        )}
        {status !== 'pending' && (
          <div
            style={{
              width: 100,
              height: 100,
              borderRadius: '50%',
              border: `4px solid ${
                status === 'success' ? '#4caf50' : '#f44336'
              }`,
            }}
          />
        )}
        <Box
          top={0}
          left={0}
          bottom={0}
          right={0}
          position="absolute"
          display="flex"
          alignItems="center"
          justifyContent="center"
        >
          {getIcon()}
        </Box>
      </Box>
      <Typography
        variant="body1"
        style={{
          marginTop: 12,
          fontSize: 18,
          fontWeight: 'bold',
          color:
            status === 'success'
              ? '#337b35'
              : status === 'error'
              ? '#ad3e36'
              : '#555',
        }}
      >
        {getText()}
      </Typography>
    </div>
  );
};

export default DeviceValidationStatus;
